
import { ThemeResponse } from "../../types/ThemeType";
import { put, delEmptyBody, post, get } from "../../utils/axios-config";
import { Theme_Preferences } from "../../utils/constants";


// export type ThemeRequest = {
//   userId: string;
//   appearance: "inherit" | "light" | "dark";
//   accentColor:  "gray"| "gold"|"bronze"| "brown"| "yellow"| "amber"| "orange"| "tomato"|"red"| "ruby"| "crimson"| "pink"| "plum"| "purple"| "violet"| "iris"| "indigo"| "blue"| "cyan"| "teal"|"jade"| "green"| "grass"| "lime"| "mint"| "sky";
//   grayColor: "auto" | "gray" | "mauve" | "slate" | "sage" | "olive" | "sand";
//   radius: "none" | "small" | "medium" | "large" | "full";
//   scaling: "90%" | "95%" | "100%" | "105%" | "110%";
// };



export const createThemePreferencesProperties = (body: ThemeResponse) =>
  post<ThemeResponse, string>(Theme_Preferences, body);

export const updateThemePreferencesProperties = (id: string, body: ThemeResponse) =>
  put<ThemeResponse, string>(`${Theme_Preferences}/${id}`, body);

export const getThemePreferencesProperties = async () => {
  return await get< ThemeResponse>(Theme_Preferences );
};

export const deleteThemePreferencesProperties = async (id: string) => {
  return await delEmptyBody<any>(`${Theme_Preferences }/${id}`);

};
